import { useEffect } from 'react';
import { QueryClientProvider } from '@tanstack/react-query';
import { BrowserRouter } from 'react-router-dom';
import { queryClient } from './lib/query-client';
import { AppRoutes } from './routes';
import { useWorkspaceStore } from './stores/workspace-store';

function ThemeInit() {
  const theme = useWorkspaceStore((s) => s.theme);

  useEffect(() => {
    if (theme === 'system') {
      document.documentElement.removeAttribute('data-theme');
    } else {
      document.documentElement.setAttribute('data-theme', theme);
    }
  }, [theme]);

  return null;
}

export function App() {
  return (
    <QueryClientProvider client={queryClient}>
      <BrowserRouter>
        <ThemeInit />
        <AppRoutes />
      </BrowserRouter>
    </QueryClientProvider>
  );
}
